import * as SurveyCore from "survey-core";
import { ValidateEmptyPhone, ValidatePhone } from "../validators/PhoneValidators";
import SetCountryModel from "../helpers/SetCountryModel";

export default function PhoneComponent(title: string) {
  SurveyCore.FunctionFactory.Instance.register("validateEmptyPhone", ValidateEmptyPhone);
  SurveyCore.FunctionFactory.Instance.register("validatePhone", ValidatePhone);

  SurveyCore.ComponentCollection.Instance.add({
    name: "phone_field",
    iconName: "icon-phone-field",
    title,
    onLoaded: (question) => {
      const countrycode = question.contentPanel.getQuestionByName("countrycode");
      countrycode.choices = SetCountryModel();

      // Set initial optionsCaption
      countrycode.optionsCaption = question.placeholder;

      // Listen for property changes and update live
      question.registerFunctionOnPropertyValueChanged("placeholder", () => {
        const innerDropdown = question.contentPanel.getQuestionByName("countrycode");
        if (innerDropdown) {
          innerDropdown.optionsCaption = question.placeholder;
        }
      });
    },
    elementsJSON: [
      {
        type: "dropdown",
        name: "countrycode",
        titleLocation: "hidden",
        allowClear: false,
        minWidth: 200,
        maxWidth: 200,
      },
      {
        type: "text",
        name: "phone",
        titleLocation: "hidden",
        startWithNewLine: false,
        minWidth: 200,
        enableIf: "{composite.countrycode} != null",
      },
    ],
  });
}
